// This event listener ensures that the JavaScript code runs after the DOM is fully loaded.
// Store the current page URL before the user navigates away
window.addEventListener("beforeunload", function () {
  sessionStorage.setItem("lastPageURL", window.location.href);
});

document.addEventListener("DOMContentLoaded", async function () {
  // Event listener for clicking on the CustomerPassword element.
  $("#CustomerLoginForm #CustomerPassword").on("click", function () {
    // Remove the "blink" class when the password field is clicked.
    $("#CustomerPassword").removeClass("blink");
  });
  if (!window.location.href.includes("/challenge")) {
    let lastPageURL = sessionStorage.getItem("lastPageURL");
    if (
      lastPageURL?.includes("/account/") &&
      localStorage?.getItem("lastPageViewed")?.includes("/products")
    ) {
      if (!window.location.href.includes("/products")) {
        window.location.href = localStorage.getItem("lastPageViewed");
      }
    }
  }
  // check page is product page and not account page containts
  if (
    window.location.href.includes("/products") &&
    !window.location.href.includes("/account/")
  ) {
    let params = new URL(document.location).searchParams;
    if (params.get("emailaddress")) {
      localStorage.setItem("lastPageViewed", window.location.href);
    }
  }

  if (window.location.href.includes("/challenge")) {
    localStorage.setItem("beforeChallengrPage", document.referrer);
  }
  let params = new URL(document.location).searchParams;
  var email_address =
    localStorage.getItem("emailaddress") || params.get("emailaddress");
  // Get query parameters from the URL.
  if (document.referrer.includes("/challenge")) {
    if (localStorage.getItem("lastPageViewed")) {
      let Localparams = new URL(localStorage.getItem("lastPageViewed"))
        .searchParams;
      const challengeError = document.querySelector(
        ".shopify-challenge__errors.errors"
      );
      if (
        Localparams.has("emailaddress") &&
        localStorage?.getItem("lastPageViewed")?.includes("/products") &&
        !challengeError
      ) {
        window.location.href = localStorage.getItem("lastPageViewed");
      }
    }
  }

  var customerEmail = params.get("emailaddress") || window.customerEmail;

  // Get email_address from local storage.

  if (typeof email_address !== "undefined" && email_address !== null) {
    // If email_address exists in local storage, set the placeholder and value for the password field.
    $("#CustomerLoginForm #CustomerPassword").attr(
      "placeholder",
      "Enter Password"
    );
    $("#CustomerLoginForm #CustomerEmail").val(email_address);
    if ($("#Email")) {
      $("#Email").val(email_address);
    }

    $("#CustomerLoginForm #CustomerPassword").addClass("blink");
    $("#CustomerLoginForm #CustomerPassword").focus();

    // Remove the placeholder after 2 seconds.
    setTimeout(function () {
      $("#CustomerLoginForm #CustomerPassword").attr("placeholder", "");
    }, 2000);

    // Remove email_address from local storage.
    localStorage.removeItem("emailaddress");
  } else {
    // If email_address does not exist in local storage, populate the Email field in the create_customer form.
    $("#create_customer #Email").val(
      localStorage.getItem("unknownemailaddress")
    );

    // Display an error message.
    $("#create_customer h1").after(
      '<div class="form-message form-message--error"><div class="errors"><ul><li>Please Create an account!</li></ul></div></div>'
    );

    // Remove unknownemailaddress from local storage.
    localStorage.removeItem("unknownemailaddress");
  }
  if (customerEmail) {
    try {
      // Check if the customer account exists asynchronously.
      const { isCreatedAccount, customer_id } = await checkCustomerExistOrNot(
        customerEmail?.trim(),
        window.customerID
      );
      if (isCreatedAccount) {
        // If the customer account exists, store the email address in local storage and redirect to the login page.
        localStorage.setItem("emailaddress", customerEmail);
        if (customer_id !== window.__st?.cid) {
          if (window.location.pathname.includes("/products")) {
            window.location.href = `/account/login?productUrl=${window.location.pathname}`;
          } else {
            if (!window.customerEmail) {
              window.location.href = "/account/login/";
            }
          }
        }
        if (document.referrer.includes("/challenge")) {
          if (localStorage.getItem("lastPageViewed")?.includes("/products")) {
            window.location.href = localStorage.getItem("lastPageViewed");
          }
        }
      } else {
        // If the customer account does not exist, redirect to the registration page and store the email address in local storage.

        localStorage.setItem("unknownemailaddress", customerEmail);

        if (
          !window.location.pathname.includes("/challenge") &&
          !window.__st?.cid
        ) {
          if (!window.location.pathname.includes("/register")) {
            if (window.location.pathname.includes("/products")) {
              window.location.href = `/account/register?productUrl=${window.location.pathname}${window.location.search}`;
            } else {
              window.location.href = "/account/register/";
            }
          }
        }
      }
    } catch (error) {
      console.log("AJAX error:", error);
    }
  } else {
    // If customerEmail is not provided, return false.
    return false;
  }

  if (window.location.href.indexOf("/register") > -1) {
    // Store the emailaddress query parameter in local storage.
    localStorage.setItem("redirect_supp_data", getUrlParameter("emailaddress"));
  }
});

// Event listener for when the document is ready.
$(document).ready(function () {
  if (CustomerLoggedin) {
    setTimeout(function () {
      // Retrieve the redirect_supp_data from local storage.
      var redirect_supp_data = localStorage.getItem("redirect_supp_data");

      if (
        typeof redirect_supp_data !== "undefined" &&
        redirect_supp_data !== null
      ) {
        // Trigger a click event on an element with href="#panel2".
        $(document).find('[href="#panel2"]').trigger("click");

        // Remove the redirect_supp_data from local storage.
        localStorage.removeItem("redirect_supp_data");
      }
    }, 3000);
  }
});
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
// Asynchronous function to check if a customer account exists.
async function checkCustomerExistOrNot(email, globalCustomerID) {
  const check_referral_code_exist = getCookie("referral_code");
  let isCreatedAccount = false;
  let customer_id = null;
  const token =
    "NTE1MDEzMWEyZjFlMTNkYTYwZjJiMWVhYTAwODc2MGE1ZjNiOTMyYzM3NmEwNWRkOTA0MTAxOTE1Mjk5MDU1NDAxZDZmMzg0NDRlNWVkZDIyNmZkM2VlZjAzZDJjZDYw";
  const portalUrl = `https://backoffice.femologist.com/api/check/femologist/patient/status/${email}/v1`;

  // Send a request to check if the customer account exists.
  const customerExist = await fetch(portalUrl, {
    headers: {
      "Content-Type": "application/json",
      "x-api-key": token,
    },
  });

  // Parse the response as JSON.
  const res = await customerExist.json();
  
  if (res.status == 200) {
    isCreatedAccount = res.isCreatedAccount;
    if (isCreatedAccount || globalCustomerID) {
      const customerId = res?.customerId || globalCustomerID;
      if (customerId) {
        customer_id = customerId;
        if (
          check_referral_code_exist !== "null" ||
          check_referral_code_exist !== "false" ||
          check_referral_code_exist !== ""
        ) {
          const portalUrl = `https://backoffice.femologist.com/api/check/femologist/patient/metafield/v1`;
          const customermetafieldUpdate = await fetch(portalUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": token,
            },
            body: JSON.stringify({
              referral_code: check_referral_code_exist,
              customerId,
            }),
          });
          const res = await customermetafieldUpdate.json();
        }
      }
    }
  }
  return { isCreatedAccount, customer_id };
}
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
  
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
  
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
  };

document.addEventListener("DOMContentLoaded", function () {
  if(!getUrlParameter('referral_code')){
  if (CustomerLoggedin) {
    setTimeout(function(){addCustomertag()},1000);  
  }
}
});
async function addCustomertag() {
  
    const token =
      "NTE1MDEzMWEyZjFlMTNkYTYwZjJiMWVhYTAwODc2MGE1ZjNiOTMyYzM3NmEwNWRkOTA0MTAxOTE1Mjk5MDU1NDAxZDZmMzg0NDRlNWVkZDIyNmZkM2VlZjAzZDJjZDYw";
    const portalUrl = `https://backoffice.femologist.com/api/check/femologist/customer_tag/${customerEmail}/${window.CustomerId}/v1`;
    const customertagUpdate = await fetch(portalUrl, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": token,
      },
    });
    const res = await customertagUpdate.json();
    console.log(res);
  }
